/**
 * Registro central de imágenes de la web de SANO Moda.
 * Todas las fotos y logotipos que se ven en la página están declarados aquí,
 * cada uno con un nombre claro. Si algún día hay que cambiar una imagen,
 * solo se sustituye su enlace en este archivo y se actualiza en toda la web.
 */

import menSweatshirtsPoster from './hombre-sudaderas-jack-jones.webp';

/** Logotipo SANO (wordmark) */
export const brandLogo =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/847d1c82-de13-422d-ab9b-792365baae82_compressed_Imagen-de-ChatGPT-20-oct-2026-23_57_50.webp';

/* ---------------------------------- Portada --------------------------------- */

/** Portada · interior de la boutique */
export const heroBoutique =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/3af666aa-f62c-401a-ad50-899b5975194a_compressed_Interior-de-boutique-moderna-en-collage.webp';

/* -------------------------------- Categorías -------------------------------- */

/** Mujer · collage de prendas de Surkana con el rótulo de Sano */
export const categoryWomen =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/7e9ba2c0-0015-4007-a02f-902d9c5024dd_compressed_Imagen-de-ChatGPT-21-oct-2026-00_26_40.webp';

/** Hombre · interior con la colección */
export const categoryMenInterior =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/0731b275-2c5c-4fa6-ae60-860f863ededa_compressed_Boutique-moderna-de-ropa-organizada.webp';

/** Hombre · estanterías ordenadas por colores */
export const categoryMenShelves =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/63147199-63fd-4413-9dc8-0855c8e6a603_compressed_Boutique-moderna-con-prendas-ordenadas.webp';

/** Hombre · cartel de sudaderas de invierno de Jack & Jones */
export const categoryMenSweatshirts = menSweatshirtsPoster;

/* --------------------------------- Historia --------------------------------- */

/** Historia · interior de la boutique */
export const heritageInterior =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/4bb0e46f-3755-4b2d-aeec-125cdfdc8053_compressed_Interior-de-boutique-moderna-con-moda-y-decoracin.webp';

/* --------------------------------- Editorial -------------------------------- */

/** Editorial · Scorzzo: chaqueta de rayas anchas y vestido geométrico */
export const editorialScorzzoJacket =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/8d71bc79-fa24-45d1-bae3-aa38a0c9ba69_compressed_scorzzo-3.webp';

/** Editorial · camisa blanca bordada y falda midi roja */
export const editorialScorzzoDress =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/d55fbe64-1fff-4df8-a56f-0ec999d4bc65_compressed_scorzzo-4.webp';

/** Editorial · vestido negro midi de Carla Ruiz */
export const editorialCarlaRuizSuit =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/717f2005-ae64-4685-9f6f-b66a2c53c536_compressed_carla-ruiz-modelo-2.webp';

/** Editorial · chaqueta de borrego con rayas anchas */
export const editorialScorzzoCoat =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/2a693410-ee3e-40e9-8911-c2161d18690a_compressed_scorzzo-1.webp';

/** Editorial · traje sastre azul marino de Carla Ruiz junto a la piscina */
export const editorialCarlaRuizNavy =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/be63409b-e86b-4e5e-a833-936c06c4debc_compressed_carla-ruiz-modelo-1.webp';

/** Editorial · cárdigan de jacquard geométrico en verde y marrón */
export const editorialScorzzoCardigan =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/426bdeab-b287-4101-9dd9-342e3c1faefa_compressed_scorzzo-2.webp';

/* --------------------------------- Instagram -------------------------------- */

/** Instagram · collage del interior de la boutique con el mostrador SANO */
export const instagramBoutique =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/ebc59e44-d2cc-4e57-baf8-66bd3a3d5686_compressed_insta-4.webp';

/** Instagram · foto antigua del escaparate de la boutique */
export const instagramVintageWindow =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/7bd8d092-325e-4490-9432-4de515088de8_compressed_Boutique-Sano_-Nostalgia-Vintage.webp';

/** Instagram · escaparate de Navidad */
export const instagramChristmasWindow =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/9b7d0f77-8164-48c8-84df-1f0b5092919e_compressed_insta-3.webp';

/** Instagram · fachada iluminada de noche */
export const instagramFacade =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/9b1ea8f2-b4a3-4ef0-8dcc-8608ed5c0e6d_compressed_insta-5.webp';

/** Instagram · percheros con vestidos de fiesta */
export const instagramDresses =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/52acd0ed-6c6b-45a8-a77a-cb731ac2578c_compressed_insta-2.webp';

/** Instagram · escaparate de rebajas */
export const instagramSaleWindow =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/0a3deab4-bc0f-4b36-9afc-2471e3a9c048_compressed_insta-1.webp';

/* ---------------------------------- Firmas ---------------------------------- */

/** Firma · Teckel Paris */
export const brandTeckelParis =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/f2c643e5-c9c2-4195-9dda-220bb6a1dc9b_compressed_Logo_teckel_paris_1.webp';

/** Firma · Ragussa */
export const brandRagussa =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/96b11fb4-b0d6-4511-ba0a-f1e269058fdd_compressed_logo_ragussa2.webp';

/** Firma · Pepaloves */
export const brandPepaloves =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/11da2d3c-f982-4152-8e7a-cc216d9c4ed0_compressed_OIP-1.webp';

/** Firma · Carla Ruiz */
export const brandCarlaRuiz =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/228e37b1-2af2-4206-8d22-953bc50bc8cf_compressed_carla-ruiz-logo-300x180.webp';

/** Firma · Tiffosi */
export const brandTiffosi =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/605fead8-5e70-461f-bd7d-f391c320ae1d_compressed_tiffosi_no_bg.webp';

/** Firma · Surkana */
export const brandSurkana =
  'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/15e599ef-71cb-4c71-8ad5-59f4981c07a9_compressed_Surkana.webp';